import { render, staticRenderFns } from "./BlogPostComment.vue?vue&type=template&id=1cf5a9b5&"
import script from "./BlogPostComment.vue?vue&type=script&lang=js&"
export * from "./BlogPostComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports